import { useCallback } from 'react';

import { useProductCenterApi } from 'api/ApplicationApi';
import { FileRemoveButton } from 'library/components/controls/files/FileRemoveButton';

export type ServiceAgreementFileRemoveButtonProps = {
	serviceAgreementFileId: number;
	onDeleted?: () => void | Promise<void>;
	disabled?: boolean;
};

export const ServiceAgreementFileRemoveButton = ({
	serviceAgreementFileId,
	onDeleted,
	disabled,
}: ServiceAgreementFileRemoveButtonProps): React.JSX.Element => {
	const { api } = useProductCenterApi();

	const deleteServiceAgreementFile = api.deleteServiceAgreementFile as (
		id: number
	) => Promise<unknown>;

	const deleteFn = useCallback(
		() => deleteServiceAgreementFile(serviceAgreementFileId),
		[deleteServiceAgreementFile, serviceAgreementFileId]
	);

	return (
		<FileRemoveButton
			deleteFn={deleteFn}
			onDeleted={onDeleted}
			disabled={disabled}
		/>
	);
};

ServiceAgreementFileRemoveButton.displayName =
	'ServiceAgreementFileRemoveButton';
